import { JSX, lazy } from "react";
import { ROUTE_PATHS } from "@/constants";

export enum RouteType {
  PUBLIC = "public",
  PRIVATE = "private",
}

interface IRoutesList {
  route_type: string;
  path: string;
  component: React.LazyExoticComponent<() => JSX.Element>;
  private?: boolean;
}

const routes: IRoutesList[] = [
  {
    route_type: RouteType.PUBLIC,
    path: "/callback",
    component: lazy(() => import("../features/callback/pages/CallbackPage")),
    private: false,
  },
  {
    route_type: RouteType.PUBLIC,
    path: ROUTE_PATHS.AUTH.LOGIN,
    component: lazy(() => import("../features/authentication/pages/LoginPage")),
    private: false,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.DASHBOARD,
    component: lazy(() => import("../features/dashboard/pages/Dashboard")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.SCHEDULE.LIST,
    component: lazy(() => import("../features/schedule/pages/SchedulePage")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.SCHEDULE.DETAIL,
    component: lazy(
      () => import("../features/schedule-detail/pages/ScheduleDetailPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.CLASS.LIST,
    component: lazy(() => import("../features/class/pages/ClassPage")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.CLASS.DETAILS,
    component: lazy(
      () => import("../features/schedule-detail/pages/ScheduleDetailPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.CLASS.SCHEDULES,
    component: lazy(
      () => import("../features/class-schedule/pages/ClassSchedulePage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.BOOKING.TRAINER.LIST,
    component: lazy(() => import("../features/booking/pages/TrainerPage")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.BOOKING.TRAINER.DETAIL,
    component: lazy(
      () => import("../features/booking/pages/TrainerDetailPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.BOOKING.TRAINER.SCHEDULES,
    component: lazy(
      () => import("../features/booking/pages/TrainerShedulePage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.BOOKING.TRAINER.PROGRAMS,
    component: lazy(
      () => import("../features/booking/pages/TrainingProgramPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.FACILITIES.LIST,
    component: lazy(
      () => import("../features/facility/pages/FacilitiesPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.FACILITIES.DETAIL,
    component: lazy(
      () => import("../features/facility/pages/FacilityDetailPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.FACILITIES.BOOKING,
    component: lazy(
      () => import("../features/facility/pages/FacilityBookingPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.MYBOOKING.LIST,
    component: lazy(() => import("../features/my-booking/pages/MyBookingPage")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.MEMBER.INFORMATION,
    component: lazy(() => import("../features/member/pages/MemberPage")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.MEMBER.POINT,
    component: lazy(() => import("../features/member/pages/MemberPointPage")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.MEMBER.PAY_WITH_QR,
    component: lazy(() => import("../features/member/pages/PayWithQRCodePage")),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.MEMBER.GOAL_SETTING_DETAIL,
    component: lazy(
      () => import("../features/member/pages/MemberGoalSettingDetailPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.MEMBER.GOAL_SETTING_MORE_DETAIL,
    component: lazy(
      () => import("../features/member/pages/MemberGoalSettingMoreDetailPage")
    ),
    private: true,
  },
  {
    route_type: RouteType.PRIVATE,
    path: ROUTE_PATHS.MEMBER.GOAL_SETTING_TRAINNING_INFO,
    component: lazy(
      () => import("../features/member/pages/MemberGoalSettingTrainingInfoPage")
    ),
    private: true,
  },
];

export default routes;
